<div class="side-padding sm:px-0">
  <div class="bg-white rounded-10 p-5 max-sm:p-3 pb-0 max-sm:pb-0">
    <app-breadcrumbs
      [infoBreadcrumb]="{
        sport:
          teamInfo && teamInfo.sport
            ? this.sportsServices.getSelectedSport()
            : 'Sports.Football',
        icon: this.sportsServices.getSelectedSport(),
        name: teamInfo.name,
        logo:
          teamInfo.national === 0
            ? teamInfo.logo
              ? teamInfo.logo
              : urlIMG + 'default.png'
            : teamInfo.country_logo
            ? teamInfo.country_logo
            : urlIMG + 'default.png'
      }"
      *ngIf="!loader"
    ></app-breadcrumbs>

    <nz-skeleton
      *ngIf="loader"
      [nzActive]="true"
      [nzLoading]="true"
      class="pb-4 max-sm:pb-2"
    >
    </nz-skeleton>

    <div
      class="bg-scores bg-top w-full h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 flex text-white items-center px-10 max-sm:px-3 gap-5 max-sm:gap-3"
      *ngIf="!loader"
    >
      <div
        class="w-[150px] h-[150px] p-4 max-sm:p-2 max-sm:w-[57px] max-sm:h-[57px] bg-white rounded-full flex justify-center items-center"
      >
        <img
          alt="country_logo"
          class="w-[105px] h-[105px] max-sm:w-[40px] max-sm:h-[40px] object-contain"
          [src]="
            teamInfo.national === 0
              ? teamInfo.logo
                ? teamInfo.logo
                : urlIMG + 'default.png'
              : teamInfo.country_logo
              ? teamInfo.country_logo
              : urlIMG + 'default.png'
          "
        />
      </div>
      <div class="flex items-center font-inter-600">
        <h1 class="text-32 max-sm:text-14 mr-2 text-white">
          {{ teamInfo.name || "NA" }}
        </h1>
        <!-- TODO: delete favorite -->
        <!-- <img
          alt="fav"
          class="cursor-pointer max-sm:w-[15px]"
          [src]="
            urlSVG + (teamInfo.favorite ? 'fav-red.svg' : 'fav-outlined.svg')
          "
          (click)="$event.stopPropagation(); markTeamFavorite(teamInfo)"
        /> -->
      </div>
    </div>

    <ng-container *ngIf="!loader">
      <div class="pt-4 max-sm:pt-2"></div>
      <app-tab-bar
        [selectedIndex]="selectedIndex"
        filtersOptions="team"
        (selectedIndexChange)="menuSelected($event)"
        *ngIf="!loader"
      ></app-tab-bar>
    </ng-container>
  </div>

  <div class="pt-4 max-sm:pt-2" *ngIf="!loader">
    <!-- Match Tab -->
    <ng-container *ngIf="selectedIndex === 0">
      <!-- <div class="font-roboto-500 text-18 max-sm:text-14">
        {{ "MatchesToday" | translate }}
      </div>
      <app-today-matches
        [idCompetition]="teamInfo.id"
        [type]="'Team'"
      ></app-today-matches> -->

      <div class="font-roboto-500 text-18 max-sm:text-14">
        {{ "NextMatches" | translate }}
      </div>

      <app-next-matches
        [idCompetition]="teamInfo.id"
        [type]="'Team'"
      ></app-next-matches>
    </ng-container>

    <!-- Next Matches Tab -->
    <ng-container *ngIf="selectedIndex === 1">
      <app-lastes-matches
        *ngIf="selectedIndex === 1"
        [idCompetition]="teamInfo.id"
        [type]="'Team'"
      ></app-lastes-matches>
    </ng-container>

    <!-- Standings Tab -->
    <ng-container *ngIf="selectedIndex === 2">
      <app-standings-football
        *ngIf="sportsServices.getSelectedSport() === 'Futbol'"
        [idCompetition]="teamInfo.competition_id"
      ></app-standings-football>
      <app-standings-sports
        *ngIf="sportsServices.getSelectedSport() !== 'Futbol'"
        [idCompetition]="teamInfo.competition_id"
      ></app-standings-sports>
    </ng-container>

    <!-- Equipments Tab -->
    <ng-container *ngIf="selectedIndex === 3">
      <app-equipments [informationTeam]="teamInfo"></app-equipments>
    </ng-container>
  </div>
</div>
